export const LOGIN = '[AUTH] LOGIN';
export const GET_USER_DATA = '[AUTH] GET_USER_DATA';
export const LOGOUT = '[AUTH] LOGOUT';
